export function concatenateVehicleInfo(vehicleInfo) {
  if (!vehicleInfo) {
    return null;
  }

  return [vehicleInfo?.year, vehicleInfo?.make, vehicleInfo?.model, vehicleInfo?.trim].join(' ');
};
